import React, { memo } from 'react';

import { Availabilities } from '../../../../../../types/Activity';
import S from '../AvailabilitiesRows.styles';

type Props = {
  item: Availabilities;
  disabled: boolean;
  text: string;
  setSelectedAvailability(availability: Availabilities | null): void;
  selected?: boolean;
};
const AvailabilitiesItem = memo(
  ({ item, disabled, text, setSelectedAvailability, selected }: Props) => {
    return (
      <S.AvailabilitiesButton
        onClick={() => {
          setSelectedAvailability(item);
        }}
        selected={selected}
        disabled={disabled}
        className='btn btn-primary'
      >
        {text}
      </S.AvailabilitiesButton>
    );
  }
);

export default AvailabilitiesItem;
